<div class="mt-26 pl-72 pr-72">
  <div class="flex flex-row justify-between mb-20">
    <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
    <button class="btn-link mat-subtitle-2 fs-14 fw-600 mb-16 refresh-icon p-10 flex justify-center items-center h-32"
      (click)="refreshInstances();">
      <mat-icon svgIcon="refresh" class="mr-8" [@rotate]="count" (@rotate.done)="isLoading && count=count+1"></mat-icon>
      {{'INSTANCE_SUMMARY.REFRESH' | transloco}}
    </button>
  </div>

  <div *ngIf="!isLoading; else loaderSpinner">

  <div class="flex flex-row justify-between">
    <div class="flex flex-row flex-auto header-section p-24 mt--20" [ngClass]="isActivityInProgress? 'remove-border' : ''">
      <div class="flex flex-row items-center">
        <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0 mr-24" (click)="goToInstances()"></mat-icon>
      </div>
      <div class="flex flex-col flex-auto justify-between pr-20 ">
        <div class="flex flex-row justify-between mb-12 place-items-center">
          <div class="flex flex-row items-center">
            <div *ngIf="data?.name; else headerLoader" class="mat-subtitle-1 fw-600 mb-0 mr-24">{{ data?.name }}</div>
            <div class="flex flex-row justify-center items-center">
              <mat-spinner *ngIf="loaderStatus.includes(data?.status)" diameter="20"
                class="mr-8"
                color="primary"
                mode="indeterminate">
              </mat-spinner>
              <div class="flex flex-row justify-center items-center pt-4 pb-4 pr-8 fw-600"
                [ngClass]="data?.status === DeployStatus.TERMINATION_FAILED || data?.status === DeployStatus.CONFIGURATION_FAILED  || data?.status === DeployStatus.TEST_FAILED  || data?.status === DeployStatus.FAILED || data?.status === DeployStatus.UPDATE_FAILED ? 'failed': data?.status">
                <mat-icon *ngIf="statusIcons[data?.status]" [svgIcon]="statusIcons[data?.status]"
                  class="icon-md p-2 mr-8" [ngClass]="data?.status === DeployStatus.DEPLOYED || data?.status === DeployStatus.UPDATED ? 'sucess-circle': 'failed-circle'"></mat-icon>
                <div>{{data?.status | titlecase}}</div>
              </div>
            </div>
          </div>

          <div class="flex flex-row justify-center items-center">
            <mat-card appearance="outlined" class="mr-20" *ngIf="(data?.agentStatus || data?.agentStatus === null || data?.agentStatus === undefined); else loader">
              <mat-card-content class="p-10">
                <div class="flex flex-row justify-between items-center">
                  <img class="icon-lg mr-10"
                    [src]="(data?.agentStatus === AgentStatus.STOPPED || data?.agentStatus === null || data?.agentStatus === undefined) ? '/assets/images/admin_panel_settings_stop.png' : '/assets/images/admin_panel_settings_start.png'" />
                  <div class=" flex flex-row mat-subtitle-2 fs-14 fw-500">
                    <span class="mat-subtitle-2 fs-14 fw-500">Tenant Agent : &nbsp;</span>
                    <span [ngClass]="{'green-1-fg': (data?.agentStatus === AgentStatus.RUNNING || data?.agentStatus != null || data?.agentStatus != undefined), 'warn-solid-fg':(data?.agentStatus === AgentStatus.STOPPED)}">
                      <span *ngIf="(data?.agentStatus || data?.agentStatus != null || data?.agentStatus != undefined); else notAvail"> {{data?.agentStatus | titlecase}}</span>
                      <ng-template #notAvail>-</ng-template>
                    </span>
                  </div>
                  <div class="flex flex-row"> &nbsp;&nbsp;
                    | &nbsp; Version :
                    <span
                      *ngIf="(data?.agentVersion || data?.agentVersion === null || data?.agentVersion === undefined); else notAvail">&nbsp;{{data?.agentVersion}}</span>
                    <ng-template #notAvail>-</ng-template>
                  </div>
                </div>

              </mat-card-content>
            </mat-card>

            <ng-template #loader>
              <div class="flex flex-col pl-6 skeleton-loader pt-16 pb-32 w-25-percent">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
            <button class="white-bg" *ngIf="(data?.agentStatus || data?.agentStatus === null || data?.agentStatus === undefined || data?.agentStatus != DeployStatus.TERMINATED || data?.agentStatus != DeployStatus.TERMINATING || data?.agentStatus != DeployStatus.TERMINATION_FAILED); else loader" matTooltipClass="form-tooltip above"
              matTooltipPosition="{{Constants.POSITION_ABOVE}}"  [matTooltipDisabled]="(data?.status === DeployStatus.STOPPING_AGENT || data?.status === DeployStatus.STARTING_AGENT) ? false : true"
              [matTooltip]="(data?.status === DeployStatus.STARTING_AGENT)  ? ('INSTANCE_SUMMARY.TOOLTIP.AGENT_START_INPROGRESS' | transloco) : ('INSTANCE_SUMMARY.TOOLTIP.AGENT_STOP_INPROGRESS' | transloco)"
               [ngClass]="{'disabled-status-btn': (data?.status === DeployStatus.STOPPING_AGENT || data?.status === DeployStatus.STARTING_AGENT || data?.status === DeployStatus.STARTING || data?.status === DeployStatus.STOPPED || data?.status === DeployStatus.START_FAILED || data?.status === DeployStatus.STOPPING || !(data.status | isNotIn : INSTANCE_DEPLOYING_STATES)), 'disabled': ((data?.dataZone === DataZone.DEVELOPMENT && !permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_NONPII]) ||
                (data?.dataZone === DataZone.SECURE && !permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_PII]) || (data?.dataZone === DataZone.LIVE && !permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_LIVE])),
                 'agent-status-stopped': ((data?.agentStatus ===  AgentStatus.RUNNING && data?.status != DeployStatus.DEPLOYED) || (data?.agentStatus ===  AgentStatus.RUNNING && data?.status === DeployStatus.DEPLOYED)), 'agent-status-running': (data?.agentStatus ===  AgentStatus.STOPPED || data?.status === DeployStatus.DEPLOYED || data?.status === DeployStatus.CONFIGURATION_FAILED)}">
              <div class="flex flex-row justify-between items-center"
                (click)="(data?.status !== DeployStatus.STOPPING_AGENT && data?.status !== DeployStatus.STARTING_AGENT && data?.status !== DeployStatus.FAILED && data?.status !== DeployStatus.STARTING && data?.status !== DeployStatus.STOPPED && data?.status !== DeployStatus.START_FAILED && data?.status !== DeployStatus.STOPPING) ? changeAgentStatus(data): null;">
                <img class="icon-md mr-10"
                  [src]="(data?.agentStatus === AgentStatus.STOPPED || data?.agentStatus === null || data?.agentStatus === undefined) ? '/assets/images/start_circle.svg' : '/assets/images/stop_circle.svg'" />
                <div [ngClass]="{'warn-solid-fg': ((data?.agentStatus ===  AgentStatus.RUNNING && data?.status != DeployStatus.DEPLOYED) || (data?.agentStatus ===  AgentStatus.RUNNING && data?.status === DeployStatus.DEPLOYED)), 'green-1-fg':(data?.agentStatus === AgentStatus.STOPPED|| data?.status === DeployStatus.DEPLOYED || data?.status === DeployStatus.CONFIGURATION_FAILED )}">
                  {{displayAgentStatus(data?.agentStatus)}}</div>
              </div>
            </button>
            <div *ngIf="data?.agentStatus && (data?.dataZone === DataZone.DEVELOPMENT && !permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_NONPII]) || (data?.dataZone === DataZone.SECURE && !permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_PII]) ||
              (data?.dataZone === DataZone.LIVE && !permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_LIVE])" class="tbl-cell col-action lock-button">
              <div class="flex justify-center"><mat-icon matTooltipClass="above" matTooltipPosition="above" [matTooltip]="'DISASTER_RECOVERY.TOOLTIP_MESSAGE' | transloco" svgIcon="lock" class="icon-md"></mat-icon></div>
            </div>


          </div>
        </div>

        <div class="flex justify-between">
          <div class="flex flex-row sub-header items-center"> 
            <div class="flex flex-row justify-center items-center vertical-indicator pr-16 fs-14">
              <span>{{'INSTANCE_DETAILS.SERVICE_DEFINITION' | transloco}}: {{serviceName ? serviceName : '-'}}</span>
            </div>
            <div class="flex flex-row justify-center items-center vertical-indicator ml-16 pr-16 fs-14">
              <mat-icon svgIcon="inventory_2" class="icon-sm mr-6"></mat-icon>
              <span>{{('INSTANCE_DETAILS.RELEASE_PACKAGE' | transloco) + ':-' }}</span>
            </div>
            <div class="flex flex-row justify-center items-center ml-16 pr-16 fs-14">
              <mat-icon svgIcon="token" class="icon-sm mr-6"></mat-icon>
              <span class="mr-10">
                {{('BLUEPRINT_SUMMARY.RELEASE' | transloco) + ': ' +
                (data?.status === DeployStatus.NOT_DEPLOYED  ? '-' : latestReleaseVersion ? latestReleaseVersion : '-') }}
              </span>
              <div *ngIf="isAMR" class="flex flex-row justify-center items-center vertical-dash pl-10">
                {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
              </div>
            </div>  
            <!-- <div class="flex flex-row pl-16 fs-14">
              <mat-icon svgIcon="open_in_new" class="icon-sm mt-2 mr-4"></mat-icon>
              <div>
                <a class="view-release-internal-link cursor-pointer pb-0"
                *ngIf="viewReleaseNotes; else releaseNotesDisabled" [href]="viewReleaseNotes"
                target="_blank">{{'BLUEPRINT_SUMMARY.RELEASE_NOTES' | transloco}}</a>
              <ng-template #releaseNotesDisabled>
                <div class="view-release-internal-link disabled-link cursor-default">
                  {{'BLUEPRINT_SUMMARY.RELEASE_NOTES' | transloco}}</div>
              </ng-template>
              </div>
            </div>   -->
            <ng-template #loader>
              <div class="pl-6 skeleton-loader pr-16">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
            <ng-template #headerLoader>
              <div class="pl-6 skeleton-loader-header">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
          <div class="flex flex-row justify-end items-end">
            <span class="fw-400 fs-14 modified-by-color">{{'INSTANCE_DETAILS.MODIFIED_BY' | transloco}}:</span><div>&nbsp;</div><span class="fw-500 fs-16">{{data?.modifiedBy ? data?.modifiedBy : '-'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>


<div class="ml-48 mr-48">
  <app-instance-details *ngIf="data && solution"
    [data]="data"
    [solution]="solution"
    [isLoading]="isLoading"
    [getBlueprints]="blueprint"
    [instanceDetailsKeys]="instanceDetailsKeys"
  ></app-instance-details>
  <mat-card *ngIf="isLoading" class="spinner flex flex-row justify-center items-center">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
</div>
</div>

<ng-template #loaderSpinner>
  <div class="flex justify-center items-center pt-64">
    <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
  </div>
</ng-template>

</div>



